import { LoadState } from "../../constants/enums";
import { IBankfund24Data, IBankfund24DataState } from "./bankfund24.types";

export const defaultBankfund24Data: IBankfund24Data = {
    bankfund24_id: null,
    name: null,
    phone: null,
    email: null,
    location: null,
    annual_income: null,
    loan_amount: null,
    loan_type: null,
    status: null,
    comment: null,
    create_dt: null,
    insert_dt: null,
};

export const Bankfund24DataInitialState: IBankfund24DataState = {
    list: {
        data: [],
        totalRecords: 0,
        loading: LoadState.NotLoaded,
        error: null,
    },
    bankfund24Data: {
        data: defaultBankfund24Data,
        loading: LoadState.NotLoaded,
        error: null,
    },
}; 